<table>
	<tr>
		@for (datum of data; track $index) {
			<td [class]="getCijferClass(datum)" [appTooltip]="datum?.tooltip">
				{{ getCijferOfLabel(datum) }}
			</td>
		}
	</tr>
</table>
